<template>
  <div class="container">
    <img
      class="goback"
      :class="[$store.state.isMirroring && 'mirror']"
      src="@/assets/back_new.png"
      alt=""
      :style="{ top: `calc(0.2rem + ${$store.state.statusBarHeight}px)` }"
      @click="goback"
    />
    <img class="top_bg" src="@/assets/top_bg.png" alt="" />
    <img class="bottom_bg" src="@/assets/bottom_bg_right.png" alt="" />
    <div id="title" class="title">
      <div>
        <img v-show="loginType == 'PHONE'" class="title_icon" src="@/assets/phone_text.png" alt="" />
        <img v-show="loginType == 'EMAIL'" class="title_icon" src="@/assets/email_text.png" alt="" />
      </div>
    </div>
    <div class="box">
      <router-link
        class="select_country"
        v-show="loginType == 'PHONE'"
        :to="{
          name: 'Country',
          query: { redirect: 'inputAccount' },
          params: { loginType: loginType }
        }"
        replace
      >
        <img v-if="!country" class="select_country_img" src="@/assets/common_country.png" alt="" />
        <img v-if="country" class="select_country_img" :src="country.countryFlagUrl" />
        <span v-if="!areaCode" class="select_country_info">
          {{ $t('common.countrySelect') }}
        </span>
        <span v-if="showInvalidAreaCode" class="select_country_info">
          {{ $t('loginAndRegister.invalidAreaCodeToast') }}
        </span>
        <span v-if="country" class="select_country_info valid_country">
          {{ country.countryName }}
        </span>
        <img
          :class="$store.state.isMirroring && 'mirror'"
          class="select_country_arrow"
          src="@/assets/common_guide_arrow.png"
        />
      </router-link>
      <div v-show="loginType === 'PHONE'" class="country_toast">
        <img class="note_icon" src="@/assets/note_icon.png" alt="" />
        {{ $t('common.countryUnmodifiedNote') }}
      </div>
      <div v-if="loginType === 'PHONE'" class="input_box">
        +
        <input
          class="input_area area_code_input"
          :class="[$store.state.isMirroring && 'mirror']"
          v-model="areaCode"
          type="tel"
          inputmode="numeric"
          autocomplete="off"
          @blur="onBlur"
          @focus="onFocus"
        />
        <div class="split"></div>
        <input
          ref="phoneInputRef"
          class="input_area"
          :class="[$store.state.isMirroring && 'mirror']"
          v-model="account"
          type="tel"
          :placeholder="$t('common.phone')"
          inputmode="numeric"
          autocomplete="off"
          @blur="onBlur"
          @focus="onFocus"
        />
        <img
          v-if="account"
          class="clear_icon"
          src="@/assets/clear_icon.png"
          alt=""
          @touchend.stop.prevent="clearPhone"
        />
      </div>
      <CommonInput
        v-if="loginType === 'EMAIL'"
        v-model="account"
        :placeholder="$t('redesign.emailPlaceholder')"
        :on-blur="onBlur"
        :on-focus="onFocus"
        show-clear
        auto-focus
      ></CommonInput>
      <div v-show="accountError" class="country_toast">
        <img class="note_icon" src="@/assets/note_icon.png" alt="" />
        {{
          loginType === 'EMAIL'
            ? $t('loginAndRegister.emailFormatToast')
            : $t('loginAndRegister.phoneNumberFormatToast')
        }}
      </div>
      <CommonBtn
        class="next_btn"
        :text="$t('common.next')"
        :disabled="disableNext"
        :on-click="toLoginOrRegister"
      ></CommonBtn>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import CommonInput from '@/components/CommonInput.vue'
import CommonBtn from '@/components/CommonBtn.vue'
import { postReportLog } from '../utils/log'
import { parseCountryFromParams, resolveCountry, syncSelectedCountryOnAreaCodeChange, flattenCountryList, isInvalidAreaCode } from '@/utils/country'
export default {
  components: { CommonInput, CommonBtn },
  data() {
    return {
      account: '',
      loginType: '',
      accountError: true,
      areaCode: '',
      countryList: [],
      countryListReady: false,
      selectedCountry: null
    }
  },
  computed: {
    disableNext() {
      this.checkAccount()
      if (this.loginType === 'EMAIL') {
        return !this.account || this.accountError
      } else if (this.loginType === 'PHONE') {
        return !this.account || !this.areaCode || this.accountError
      } else {
        return true
      }
    },
    country() {
      return resolveCountry({
        selectedCountry: this.selectedCountry,
        countryList: this.countryList,
        areaCode: this.areaCode
      })
    },
    showInvalidAreaCode() {
      return isInvalidAreaCode({
        areaCode: this.areaCode,
        countryList: this.countryList,
        countryListReady: this.countryListReady
      })
    }
  },
  watch: {
    account() {
      this.checkAccount()
    },
    areaCode(val) {
      this.selectedCountry = syncSelectedCountryOnAreaCodeChange(this.selectedCountry, this.countryList, val)
    },
    countryList(list) {
      if (list.length && this.areaCode) {
        this.selectedCountry = syncSelectedCountryOnAreaCodeChange(this.selectedCountry, list, this.areaCode)
      }
    },
    '$route.params'() {
      this.applyCountryFromRoute()
    }
  },
  mounted() {
    let paramsData = JSON.parse(localStorage.getItem('paramsData') || '{}')
    let acctDataFormChamet = JSON.parse(sessionStorage.getItem('acctData') || '{}')
    const currentLoginType = this.$route.query.loginType || this.$route.params.loginType
    // 曝光埋点
    postReportLog({
      log_id: '440',
      extra: {
        page: 'input_account',
        login_type: currentLoginType
      }
    })
    if (
      (acctDataFormChamet.phone && currentLoginType === 'PHONE') ||
      (acctDataFormChamet.email && currentLoginType === 'EMAIL')
    ) {
      // 当前登录方式与acctData中的登录方式相同，优先使用acctData
      this.account = currentLoginType === 'PHONE' ? acctDataFormChamet.phone : acctDataFormChamet.email
      this.areaCode = this.$route.params.areaCode || acctDataFormChamet.areaCode
      this.loginType = currentLoginType
    } else if (paramsData.registerType === currentLoginType) {
      // 当前登录方式与paramsData中的登录方式相同，使用paramsData
      this.account = paramsData.account
      this.areaCode = this.$route.params.areaCode || paramsData.areaCode
      this.loginType = paramsData.registerType
      if (!this.$route.params.country && !this.$route.params.countryNo && paramsData.countryNo) {
        this.selectedCountry = parseCountryFromParams(paramsData)
      }
    } else {
      // 都不匹配，使用路由参数
      this.loginType = currentLoginType
      this.areaCode = this.$route.params.areaCode
    }
    this.applyCountryFromRoute()
    if (!this.loginType) {
      this.goback()
    }
    if (this.loginType === 'PHONE') {
      !this.areaCode && this.getAreaCodeByIP()
      this.$nextTick(() => {
        this.$refs.phoneInputRef.focus()
      })
    }
    this.getCountryList()
  },
  methods: {
    applyCountryFromRoute() {
      const country = parseCountryFromParams(this.$route.params)
      if (country) {
        this.selectedCountry = country
        this.areaCode = country.areaCode
      }
    },
    onFocus() {
      this.updatePageStyle('focus')
    },
    onBlur() {
      this.updatePageStyle('blur')
      this.checkAccount()
    },
    updatePageStyle(event) {
      const title = document.getElementById('title')
      if (title) {
        title.style.marginTop = event === 'focus' ? '0.82rem' : '1.42rem'
      }
    },
    getAreaCodeByIP() {
      this.$http.get(window.serverPath + '/api/auth/getIpDetail').then((res) => {
        if (res.data.code === '200') {
          this.areaCode = res.data.data.areaCode
        }
      })
    },
    getCountryList() {
      this.$http
        .get(window.serverPath + '/api/country/getNewAreaCodeList')
        .then((res) => {
          if (res.data.code === '200') {
            this.countryList = flattenCountryList(res.data.data)
          }
        })
        .finally(() => {
          this.countryListReady = true
        })
    },
    clearPhone() {
      this.account = ''
    },
    checkAccount() {
      if (!this.account) {
        this.accountError = false
        return
      }
      if (this.loginType === 'EMAIL') {
        const regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        this.accountError = !regEmail.test(this.account)
      } else {
        const regPhone = /^[0-9]{7,11}$/
        this.accountError = !regPhone.test(this.account)
      }
    },
    goback() {
      localStorage.removeItem('paramsData')
      this.$router.back()
    },
    toLoginOrRegister() {
      if (this.loginType === 'PHONE' && !/^\d+$/.test(String(this.areaCode))) {
        Toast(this.$t('loginAndRegister.invalidAreaCodeToast'))
        return
      }
      const $this = this
      let account = this.loginType === 'EMAIL' ? this.account : `${this.areaCode}${this.account}`
      // 绑定钱包流程埋点 - step3 填写账号并点击 Next
      postReportLog({
        log_id: '477',
        extra: {
          step: '3',
          bind_type: this.loginType === 'EMAIL' ? 'email' : 'phone', // 绑定方式
          bind_account: account // 绑定邮件/电话号码
        }
      })
      const params = {
        type: this.loginType,
        account: account,
        apptype: localStorage.getItem('apptype') || ''
      }
      $this.$http
        .post(window.serverPath + '/api/auth/getLoginOrRegisterStatus', params)
        .then((res) => {
          if (res.data.code === '200') {
            let paramsData = {
              account: this.account,
              areaCode: this.areaCode,
              country: this.country || null,
              countryNo: this.country ? this.country.countryNo : '',
              countryName: this.country ? this.country.countryName : '',
              countryFlagUrl: this.country ? this.country.countryFlagUrl : '',
              registerType: this.loginType,
              loginType: 'password'
            }
            localStorage.setItem('paramsData', JSON.stringify(paramsData))
            if (res.data.message === 'login') {
              this.$router.replace({
                name: 'Login',
                params: paramsData
              })
            } else if (res.data.message === 'register') {
              if (!localStorage.getItem('apptype')) {
                Toast('Currently account is unregistered.')
              } else {
                paramsData.account = this.account.toLowerCase()
                this.$router.replace({
                  name: 'Register',
                  params: paramsData
                })
              }
            } else {
              Toast(res.data.message)
            }
          } else if (res.data.code === '60011') {
            Toast(res.data.message)
          } else {
            Toast({
              message: this.$t('loginAndRegister.emailFormatToast')
            })
          }
        })
        .catch((err) => {
          console.log('异常', err)
        })
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #d9ffe8 0.35%, rgba(255, 255, 255, 0) 52.27%), #f5fff9;
  padding: 0 0.24rem;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.top_bg {
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
  z-index: 1;
}

.bottom_bg {
  position: absolute;
  bottom: 0;
  width: 70%;
  right: 0;
  z-index: 1;
}

.back {
  width: 0.24rem;
  height: 0.24rem;
  position: absolute;
  top: 0.32rem;
  left: 0.24rem;
}

.title {
  width: 100%;
  margin: 1.42rem 0 0.24rem;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
}

.title_icon {
  height: 0.36rem;
  display: block;
}

.box {
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.select_country {
  width: 100%;
  padding: 0.1rem 0.16rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-radius: 0.08rem;
  height: 0.48rem;
  background: linear-gradient(90deg, rgba(67, 215, 125, 0.15) 0%, rgba(63, 187, 112, 0.15) 100%);
  display: flex;
  align-items: center;
  position: relative;
}

.select_country_info {
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
}

.select_country_info.valid_country {
  color: #2f2f2f;
  font-weight: 600;
}

.select_country_img {
  width: 0.18rem;
  height: 0.18rem;
  border-radius: 0.21rem;
  overflow: hidden;
  background-color: #f5f5f5;
  margin-inline-end: 0.12rem;
}

.select_country_arrow {
  width: 0.2rem;
  height: 0.2rem;
  position: absolute;
  right: 0.16rem;
  top: 0.14rem;
}

.select_country_arrow.mirror {
  right: auto;
  left: 0.16rem;
  transform: rotateY(180deg);
}

.input_box {
  width: 100%;
  padding: 0.1rem 0.16rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-radius: 0.08rem;
  height: 0.48rem;
  background: linear-gradient(90deg, rgba(67, 215, 125, 0.15) 0%, rgba(63, 187, 112, 0.15) 100%);
  color: #2f2f2f;
  font-size: 0.14rem;
  line-height: 0.14rem;
}

.split {
  width: 0.01rem;
  height: 0.18rem;
  margin: 0 0.12rem;
  background: #2f2f2f;
}

.input_area {
  color: #2f2f2f;
  font-size: 0.14rem;
  line-height: 0.14rem;
  text-align: left;
  height: 0.48rem;
  background: transparent;
  width: 100%;
  caret-color: #3fbb70;
  font-weight: 600;
}

.input_area.area_code_input {
  width: 0.42rem;
  margin-inline-start: 0.03rem;
}

.input_area::placeholder {
  color: #828282;
  font-weight: 400;
}

.input_area.mirror {
  text-align: right;
}

.clear_icon {
  width: 0.2rem;
  height: 0.2rem;
}

.input_inner_area_code {
  width: 0.5rem;
  display: inline-block;
  font-size: 0.14rem;
  color: #282828;
  font-weight: 600;
}

.next_btn {
  margin-top: 0.52rem;
}

.goback {
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  left: 0.18rem;
  z-index: 2;
}

.goback.mirror {
  left: auto;
  right: 0.18rem;
  transform: rotate(180deg);
}

.country_toast {
  width: 100%;
  display: flex;
  font-size: 0.12rem;
  font-weight: 400;
  color: #ff840b;
  margin: 0.06rem 0 0.12rem;
  align-items: center;
}

.note_icon {
  width: 0.12rem;
  height: 0.12rem;
  margin-inline-end: 0.02rem;
}
</style>



// WEBPACK FOOTER //
// src/views/inputAccount.vue